/**
 * Returns truncated string
 *
 * @param {string} value
 * @param {number} length
 * @returns {string}
 */
 export function truncateString(value: string, length = 50): string {
    return value.length > length ? `${value.substring(0, length + 1)}...` : value;
}